function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUserReviewStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 30c-.2 0-.4-.1-.6-.2L14.6 23H5c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h21.9c1.7 0 3 1.3 3 3v14.9c0 1.7-1.3 3-3 3H25V29c0 .4-.2.7-.6.9-.1.1-.3.1-.4.1zm-8.2-8.6L23 27v-5c0-.6.4-1.1 1-1.1h2.9c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v14.9c0 .6.4 1 1 1h10c.3 0 .6.2.8.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3 18.5c-.2 0-.3 0-.5-.1L16 16.8l-2.8 1.6c-.3.2-.8.2-1.1 0-.3-.2-.5-.6-.4-1l.6-3.4-2.4-2.4c-.3-.3-.4-.7-.2-1 .2-.3.4-.6.8-.7l3.3-.4 1.4-3c0-.5.4-.7.8-.7s.7.2.9.6l1.4 3 3.3.4c.4.1.7.3.8.7.1.4 0 .8-.2 1l-2.4 2.4.6 3.4c.1.4-.1.8-.4 1-.3.1-.5.2-.7.2zM16 14.6c.2 0 .3 0 .5.1l1.4.8-.3-1.8c-.1-.3 0-.7.3-.9l1.4-1.4-1.8-.2c-.3 0-.6-.3-.8-.6L16 9.2l-.7 1.5c-.1.3-.4.5-.8.6l-1.8.2 1.4 1.4c.2.2.3.6.3.9l-.4 1.8 1.4-.8c.2-.1.4-.2.6-.2z",
    fill: props.color
  }));
}

export default SvgIconUserReviewStar;